import { useCallback, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import {
  getPubMissionList,
  SellerPubMissionCategoryFilter,
  SellerPubMissionListItemResponse,
  SellerPubMissionStatusFilter,
} from "../../../api/pub-mission";
import { pubState } from "../../../recoil/pub.atom";

const LIMIT = 10;

export const useEventMission = () => {
  const pub = useRecoilValue(pubState);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [missionList, setMissionList] = useState<
    SellerPubMissionListItemResponse[]
  >([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [categoryFilter, setCategoryFilter] =
    useState<SellerPubMissionCategoryFilter>(
      SellerPubMissionCategoryFilter.ALL,
    );
  const [statusFilter, setStatusFilter] = useState<SellerPubMissionStatusFilter>(
    SellerPubMissionStatusFilter.ALL,
  );

  const handleSearchQueryChange = useCallback((query: string) => {
    setSearchQuery(query);
    setCurrentPage(1);
  }, []);

  const handleCategoryFilterChange = useCallback(
    (category: SellerPubMissionCategoryFilter) => {
      setCategoryFilter(category);
      setCurrentPage(1);
    },
    [],
  );

  const handleStatusFilterChange = useCallback(
    (status: SellerPubMissionStatusFilter) => {
      setStatusFilter(status);
      setCurrentPage(1);
    },
    [],
  );

  const fetchMissionList = useCallback(async () => {
    if (!pub) return;

    const res = await getPubMissionList({
      pubId: pub.id,
      page: currentPage,
      limit: LIMIT,
      name: searchQuery || undefined,
      category:
        categoryFilter === SellerPubMissionCategoryFilter.ALL
          ? undefined
          : categoryFilter,
      status:
        statusFilter === SellerPubMissionStatusFilter.ALL
          ? undefined
          : statusFilter,
    });

    setMissionList(res.list);
    setTotalCount(res.total);
    setTotalPages(Math.max(1, Math.ceil(res.total / LIMIT)));
  }, [pub, currentPage, searchQuery, categoryFilter, statusFilter]);

  useEffect(() => {
    fetchMissionList();
  }, [fetchMissionList]);

  return {
    pubId: pub?.id ?? 0,
    currentPage,
    setCurrentPage,
    totalPages,
    totalCount,
    missionList,
    searchQuery,
    categoryFilter,
    statusFilter,
    handleSearchQueryChange,
    handleCategoryFilterChange,
    handleStatusFilterChange,
    refreshMissionList: fetchMissionList,
  };
};
